import React from "react";
import Slider, { Slide } from "../Slider/Slider";

const Prices = () => {
  const slides: Slide[] = [
    {
      title: "ВКОРОТИТИ,ПОДОВЖИТИ НИЗ",
      content: [
        ["Вкоротити, подовжити джинси,штани (прямострочка)", "від 170грн"],
        ["Вкоротити джинси з оригіналом", "від 220грн"],
        ["Вкоротити, подовжити класичні штани з тасьмою", "від 220грн"],
        ["Вкоротити штани з манжетом", "від 240грн"],
        ["Вкоротити трикотажні штани (распошив)", "від 240грн"],
        ["Вкоротити трикотажні штани,світшоти з манжетом", "від 250грн"],
        ["Вкоротити штани з розрізами", "від 240грн"],
        ["Вкоротити блузу, рубашку з розрізами", "від 240грн"],
        ["Вкоротити блузу, рубашку (заокруглений низ)", "від 250грн"],
        ["Вкоротити, подовжити спідницю, сукню (прямострочка)", "від 240грн"],
        [
          "Вкоротити напівсонце, сонце спідницю, сукню (прямострочка)",
          "від 280грн",
        ],
        ["Вкоротити весільну сукню (кожен шар)", "від 300грн"],
        ["Вкоротити спідницю, сукню (распошив)", "від 250грн"],
        ["Вкоротити спідницю, сукню (пікування)", "від 250грн"],
      ],
    },
    {
      title: "ВКОРОТИТИ,ПОДОВЖИТИ НИЗ",
      content: [
        ["Вкоротити футболку (распошив)", "від 220грн"],
        ["Вкоротити футболку з розрізами", "від 250грн"],
        ["Вкоротити низ піджака, пальто (без шлиці)", "від 300грн"],
        ["Вкоротити низ піджака, пальто (з шлицею)", "від 400грн"],
        ["Вкоротити низ піджака, пальто (заокруглені борти)", "від 350грн"],
        ["Вкоротити шкіряну куртку", "від 600грн"],
        ["Вкоротити куртку (синтапон)", "від 400грн"],
        ["Вкоротити куртку (пух)", "від 450грн"],
        ["Вкоротити низ куртки з манжетом", "від 350грн"],
        ["Вкоротити шубу", "від 750грн"],
        ["Подовжити сукню, спідницю (мережевом, тканиною)", "від 250грн"],
        ["Подовжити рукава сукні, блузи (мереживом, тканиною)", "від 250грн"],
      ],
    },

    {
      title: "ВКОРОТИТИ РУКАВА",
      content: [
        ["Вкоротити рукава рубашки, блузи (прямострочка)", "від 200грн"],
        ["Вкоротити рукава рубашки, блузи з манжетом", "від 240грн"],
        ["Вкоротити рукава піджака, пальто (без шлиці)", "від 300грн"],
        [
          "Вкоротити рукава піджака, пальто (з шлицею, без гудзиків)",
          "від 400грн",
        ],
        ["Вкоротити рукака куртки", "від 300грн"],
      ],
    },
    {
      title: "ЗАМІНА БЛИСКАВКИ",
      content: [
        ["Заміна бликавки в джинсах", "від 220грн"],
        ["Заміна блискавки в штанах", "від 200грн"],
        ["Заміна блискавки в спідниці (потайна)", "від 200грн"],
        ["Заміна блискавки в сукні (потайна)без підкладу", "від 260грн"],
        ["Заміна блискавки в сукні (потайна)на підкладі", "від 300грн"],
        ["Заміна блискавки в спортивних кофтах (без підкладу)", "від 300грн"],
        ["Заміна блискавки в демісезонних куртках, вітровках", "від 320грн"],
        [
          "Заміна блискавки в зимових куртках (без канта і кнопок)",
          "від 380грн",
        ],
        [
          "Заміна блискавок в зимових пальто (без канта і кнопок)",
          "від 420грн",
        ],
        [
          "Заміна блискавок в зимових пальто-пух (без канта і кнопок)",
          "від 420грн",
        ],
        ["Заміна блискавок в шкіряних куртках", "від 500грн"],
        ["Заміна блискавок в рюкзаках", "від 300грн"],
      ],
    },
    {
      title: "ШТОПКА",
      content: [
        ["Штопка джинс декоративна (1шт)", "від 80грн"],
        ["Штопка джинс профілактична (1шт)", "від 140грн"],
        ["Штопка джинс при пориві (1шт)", "від 180грн"],
      ],
    },
    {
      title: "ВШИТИ, РОЗШИТИ",
      content: [
        ["Вшити, розшити джинси, штани в поясі", "від 250грн"],
        ["Вшити, розшити спортивні штани в поясі (на резинці)", "від 250грн"],
        ["Вшити джинси, штани в поясі +виточки", "від 300грн"],
        ["Вшити штани в поясі, по задньому шву", "від 300грн"],
        ["Вшити, розшити бокові шви джинс, штанів (без поясу)", "від 200грн"],
        ["Вшити, розшити штани по внутрішньому шву", "від 150грн"],
        ["Вшити спідницю по поясу", "від 280грн"],
        ["Вшити, розшити спідницю по бокових швах (без поясу)", "від 180грн"],
        ["Вшити спідницю+ блискавка", "від 250грн"],
        ["Вшити, розшити блузу, рубашку по боковиш швах", "від 200грн"],
      ],
    },
    {
      title: "ВШИТИ, РОЗШИТИ",
      content: [
        ["Вшити блузу, рубашку по задньому шву", "від 140грн"],
        ["Вшити блузу,сукню, рубашку по рукавах", "від 150 грн"],
        ["Вшити, розшити сукню по бокових швах (без підклада)", "від 250грн"],
        ["Вшити, розшити сукню по бокових швах (з підкладом)", "від 300грн"],
        ["Вшити сукню по задньому шву + блискавка", "від 260грн"],
        ["Вшити, розшити спідницю по швах ( на підкладі)", "від 300грн"],
        ["Вшити, розшити виточки в сукні", "від 120грн"],
        ["Підняти плечьові шви в сукні + пройма", "від 300грн"],
        ["Вшити, розшити піджак , пальто по швах (з підкладом)", "від 320грн"],
        ["Вшити, розшити куртку по швах (синтапон)", "від 380грн"],
        ["Вшити, розшити рукава куртки", "від 200грн"],
      ],
    },
    {
      title: "ДРІБНИЙ РЕМОНТ",
      content: [
        ["Дрібний ремонт (1шт)", "від 40грн"],
        ["Пришити ґудзик", "від 20грн"],
        ["Заміна бігунка", "від 80грн"],
        ["Пришити нашивку (одяг без підкладу)", "від 50грн"],
        ["Пришити нашивку (одяг з підкладом)", "від 80грн"],
        ["Пришити тасьму на порив (верхній одяг)", "від 200грн"],
        ["Нашити тканину на порив (верхній одяг)", "від 200грн"],
      ],
    },
    {
      title: "ТЮЛЬ, ШТОРИ",
      content: [
        ["Обробка тюлі, штор (1м/п)", "від 30грн"],
        ["Пришити тасьму вузьку (1м/п)", "від 30грн"],
        ["Пришити тасьму вузьку (1м/п)", "від 30грн"],
      ],
    },
    {
      title: "ЗАМІНА ПІДКЛАДУ",
      content: [
        ["Заміна підкладу в сукні, спідниці (без шлиці)", "від 350грн"],
        [
          "Заміна підкладу в піджаку, пальто (без внутрішніх кишень)",
          "від 650грн",
        ],
        [
          "Заміна підкладу в піджаку, пальто (з внутрішніми кишенями)",
          "від 650грн",
        ],
        ["Заміна підклада в куртці", "від 600грн"],
        ["Заміна підкладу в шкіряній куртці", "від 700грн"],
      ],
    },
    {
      title: "ПРАСУВАННЯ",
      content: [
        ["Прасування сорочки, теніски", "від 150грн"],
        ["Прасування штанів", "від 150грн"],
        ["Прасування сукні", "від 170грн"],
        ["Прасування піджака, пальто", "від 250грн"],
      ],
    },
  ];
  return (
    <div className='main-content' id='prices'>
      <h2>НАШІ ЦІНИ</h2>
      <Slider slides={slides} />
    </div>
  );
};

export default Prices;
